import { render, staticRenderFns } from "./FeedForm.vue?vue&type=template&id=327aef6a"
import script from "./FeedForm.vue?vue&type=script&lang=js"
export * from "./FeedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports